import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

export interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  eyebrow?: string;
}

/** Standard page title row for admin lending screens. */
const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actions, eyebrow }) => (
  <Box
    sx={{
      mb: 3,
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      alignItems: { xs: 'stretch', sm: 'flex-start' },
      justifyContent: 'space-between',
      gap: 2,
      animation: 'pageFadeIn 0.35s ease-out',
    }}
  >
    <Box sx={{ minWidth: 0 }}>
      {eyebrow && (
        <Typography variant="overline" sx={{ display: 'block', mb: 0.5 }}>
          {eyebrow}
        </Typography>
      )}
      <Typography variant="h4" component="h1" sx={{ mb: subtitle ? 0.5 : 0 }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 640 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    {actions && (
      <Stack
        direction="row"
        spacing={1}
        flexWrap="wrap"
        useFlexGap
        sx={{ flexShrink: 0, alignItems: 'center' }}
      >
        {actions}
      </Stack>
    )}
  </Box>
);

export default PageHeader;
